import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IEmploymentStatusDetails } from "../employmentstatusModel";

export const getAllEmploymentStatus = createAsyncThunk(
  "EmploymentStatus/FindAllEmploymentStatus",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmploymentStatus/FindAllEmploymentStatus`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching EmploymentStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getEmploymentStatusByID = createAsyncThunk(
  "EmploymentStatus/FindByIDEmploymentStatus",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmploymentStatus/FindByIDEmploymentStatus`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        Title: result?.Title,
        IsActive: result?.IsActive ? 1 : 2,
      } as IEmploymentStatusDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching EmploymentStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveEmploymentStatus = createAsyncThunk(
  "EmploymentStatus/FindAllActiveEmploymentStatus",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/EmploymentStatus/FindAllActiveEmploymentStatus`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching EmploymentStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createEmploymentStatus = createAsyncThunk(
  "EmploymentStatus/InsertEmploymentStatus",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmploymentStatus/InsertEmploymentStatus`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating EmploymentStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateEmploymentStatus = createAsyncThunk(
  "EmploymentStatus/UpdateEmploymentStatus",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmploymentStatus/UpdateEmploymentStatus`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating EmploymentStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const employmentStatusActiveInactive = createAsyncThunk(
  "EmploymentStatus/ActiveInActiveEmploymentStatus",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmploymentStatus/ActiveInActiveEmploymentStatus`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive EmploymentStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteEmploymentStatus = createAsyncThunk(
  "EmploymentStatus/DeleteEmploymentStatus",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/EmploymentStatus/DeleteEmploymentStatus`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting EmploymentStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
